export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const GET_RESET_PASSWORD = "GET_RESET_PASSWORD";

export const CHECK_RESET_PASSWORD = "CHECK_RESET_PASSWORD";
export const CHECK_RESET_PASSWORD_SUCCESS = "CHECK_RESET_PASSWORD_SUCCESS";
export const CHECK_RESET_PASSWORD_ERROR = "CHECK_RESET_PASSWORD_ERROR";
